import React from 'react';
import { Controller } from 'react-hook-form';
import type { Control } from 'react-hook-form';
import type { FormRadio } from 'types/cms';

import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@material-ui/core';

const RadioInput = ({
  control,
  identifier,
  label,
  radio_items,
  required,
}: FormRadio & { control: Control }) => {
  const formLabelId = `label-${identifier}`;
  return (
    <FormControl>
      <FormLabel id={formLabelId}>{required ? `${label} *` : label}</FormLabel>
      <Controller
        name={identifier}
        control={control}
        defaultValue=""
        render={props => (
          <RadioGroup aria-labelledby={formLabelId} {...props}>
            {radio_items.map(({ id, value, display_value }) => {
              const key = `radio-${id}`;
              return (
                <FormControlLabel
                  key={key}
                  control={<Radio required={required} />}
                  value={value}
                  label={display_value ? display_value : value}
                />
              );
            })}
          </RadioGroup>
        )}
      />
    </FormControl>
  );
};

export default RadioInput;
